export type ImageSize = "xs" | "sm" | "md" | "lg" | "xl";

export interface getUserImageOptions {
	/**
	 * Prim key of the record in atbl_Personnel_Employees
	 */
	primKey: string | null;
	/**
	 * Person ID of the employee
	 */
	login: string | null;
	/**
	 * The value of the ImageHash column in atbl_Personnel_Employees
	 */
	hash: string | number | null;
	/**
	 * The image will be resized according to this value. Default is 'xs':
	 * - xs: 64px
	 * - sm: 128px
	 * - md: 256px
	 * - lg: 512px
	 * - xl: image is not resized
	 */
	size?: ImageSize;
}

const sizeMap: Record<ImageSize, number | undefined> = {
	xs: 64,
	sm: 128,
	md: 256,
	lg: 512,
	xl: undefined,
};

/**
 * Returns the absolute path of a users profile picture. Uses the EmployeesLookup
 * data resource to enable caching across applications.
 *
 * If one of primKey or hash are not provided, or are null, an empty string will be returned.
 */
export function getUserImage(
	primKey: string | null,
	login: string | null,
	hash: string | number | null,
	size?: ImageSize,
): string;
export function getUserImage(options: getUserImageOptions): string;
export function getUserImage(
	primKeyOrOptions: string | null | getUserImageOptions,
	login?: string | null,
	hash?: string | number | null,
	size: ImageSize = "xs",
) {
	if (primKeyOrOptions && typeof primKeyOrOptions === "object") {
		return getUserImage(primKeyOrOptions.primKey, primKeyOrOptions.login, primKeyOrOptions.hash, primKeyOrOptions.size);
	}

	if (!primKeyOrOptions || !hash) {
		return "";
	}

	let sizePx = sizeMap[size];
	return `/api/data/blob/EmployeesLookup/${primKeyOrOptions}/Image/${encodeURIComponent(login ?? "")}${
		login ? "." : ""
	}${encodeURIComponent(hash)}.jpg${sizePx ? `?width=${sizePx}` : ""}`;
}
